import HomeBanner from '../components/Home/banner';
import FeaturesKA from '../components/Home/FeaturesKA';
import HomeSolutionIT from '../components/Home/solutionIT';
import HomePilot from '../components/Home/pilot';
import News from '../components/Home/Lead/News';
import HomeEffect from '../components/Home/HomeEffect';
import HomeEffectMobile from '../components/Home/HomeEffectMobile';
import Partners from '../components/Home/partners';
import PartnersSlides from '../components/Home/PartnersSlides';
import SupportedTech from '../components/Home/supportedTech';
import Setup from '../components/Home/Setup/setup';
import SetupMobile from '../components/Home/Setup/setupMobile';
import HomeAPMInstructions from '../components/Home/HomeAPMInstructions';



import Lead from '../components/Home/Lead/Lead';

import HomeEfectBizHome from '../components/Home/HomeEfectBizHome';
import PreFooter from '../components/Home/PreFooter';

function Home() {
  return (
    <>
      <div className='w-full bg-gradient-to-r from-[#202020] via-[#352f2a] to-[#ecb07b] overflow-hidden'>
        <div className='w-full py-8'>
          <HomeBanner />
        </div>
      </div>
      <News />
      <div className='w-full bg-white '>
        <div className='container mx-auto'>
          <Lead />
        </div>
      </div>
       <div className='w-full bg-white xl:pt-[20px]' id='pilot'>
        <div className="w-full overflow-hidden bg-pilot">
          <div className='container mx-auto xl:px-4 '>
            <HomePilot />
          </div>
        </div>
      </div>
      <div className='w-full bg-white xl:hidden'>
        {/* <div className='container flex justify-center items-center container mx-auto xl:px-4 '>
          <HomeEffect />
        </div> */}
      </div>
      <div className='w-full bg-white xl:h-[769px]'>
        <div className='container mx-auto px-4 py-[30px] xl:w-[1212px] hidden xl:block'>
          <Setup />
        </div>
        <div className='container mx-auto px-4 xl:hidden'>
          <SetupMobile />
        </div>
      </div>

      <div className='w-full bg-white '>
        <div className='container mx-auto px-4 xl:pb-[78px]'>
          <HomeSolutionIT />
        </div>
      </div>

      <div className='w-full bg-white '>
        <div className='container mx-auto px-4'>
          <FeaturesKA />
        </div>
      </div>

      <div className='w-full bg-white hidden lg:block'>
        <div className='container flex justify-center items-center container mx-auto xl:px-4 '>
          <HomeEffect />
        </div>
      </div>
      <div className='w-full bg-white lg:hidden'>
        <div className='container flex justify-center items-center container mx-auto '>
          <HomeEffectMobile />
        </div>
      </div>


      <div className='w-full bg-white flex flex-col xl:flex-col gap-10'>

        <div className='container mx-auto px-4'>
          <Partners />
          {/* <PartnersSlides /> */}
        </div>

        <div className='container mx-auto px-4'>
          <HomeEfectBizHome />
        </div>


        <div className='container mx-auto px-4'>
          <HomeAPMInstructions />
        </div>


        <div className='w-full h-[602px] lg:h-[435px] relative overflow-hidden bg-gradient-to-r from-[#927156] to-[#352f2a] '>
          <SupportedTech />
        </div> 
      </div>

      <div className='w-full bg-white '>
        <div className='container mx-auto px-4 xl:pb-[78px]'>
          <PreFooter />
        </div>
      </div>
    </>
  );
}

export default Home; 